import { render, staticRenderFns } from "./paymentRequest.vue?vue&type=template&id=1331ad1e"
import script from "./paymentRequest.vue?vue&type=script&lang=js"
export * from "./paymentRequest.vue?vue&type=script&lang=js"
import style0 from "./paymentRequest.vue?vue&type=style&index=0&id=1331ad1e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports